import React from "react";
import styled from "styled-components";

const DoctorRating = ({ rating }) => {
  const totalStars = 5;
  const filledStars = Math.round(rating);

  if (!rating) {
    return null;
  }

  return (
    <RatingWrapper className="rating-container">
      <p className="ratingBold">{`${parseFloat(rating).toFixed(1)}`}</p>
      <div className="ratingWrapper">
        {Array.from({ length: totalStars }, (_, index) => (
          <span key={index} className={`star ${index < filledStars ? "filled" : ""}`}>
            ★
          </span>
        ))}
      </div>
      <p>{`${parseFloat(rating)} ratings`}</p>
    </RatingWrapper>
  );
};

export default DoctorRating;
const RatingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: "100%";
  background-color: #fafafa;
  height: 150px;
  p {
    font-size: 0.9rem;
    color: gray;
  }
  .ratingBold {
    font-size: 1.4rem;
    margin-top: 1rem;
  }
  .star {
    font-size: 30px;
    color: grey;
    margin-right: 5px;
  }

  .star.filled {
    color: orange;
  }
`;
